import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Slide, Box } from '@mui/material';
import { BsDashCircleFill } from "react-icons/bs";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RDialog({ title = "Test", fullScreen = false, open = false, handleClose = () => { }, children }) {

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                PaperProps={{
                    className: "card-bg text"
                }}
            >
                <Box display={'flex'} alignItems={'center'}
                    justifyContent={'space-between'}
                    sx={{
                        borderRadius: fullScreen ? 0 : '20px 20px 0 0',
                        px: { xs: 2, md: 4 },
                        py: 1.2,
                        borderBottom: fullScreen ? '1px solid #cfcfcfff' : undefined
                    }}
                    className={fullScreen ? "top-bar card-bg" : "tab-button active"}
                >
                    <Typography fontSize={16} fontWeight={700} sx={{ letterSpacing: 0.5 }}>{title}</Typography>
                    <Box
                        onClick={handleClose}
                        sx={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: 22,
                            color: 'inherit',
                            '&:hover': { opacity: 0.8 }
                        }}
                    >
                        <BsDashCircleFill />
                    </Box>
                </Box>
                <Box sx={{ borderRadius: fullScreen ? 0 : 20, p: { xs: 2, md: 3 }, flexGrow: 1, overflowY: 'auto' }} className="card-bg1 text">
                    {children}
                </Box>
            </Dialog>
        </React.Fragment>
    );
}
